import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PublicProfile, PublicProfileTipRules } from '../models/user';
import { TipRules } from '../models/tip';
import { PublicTeam, PublicTeamTipRules } from '../models/team';

type ProfileState = {
    tipRules?: TipRules;
    publicProfile?: PublicProfile;
    publicTeam?: PublicTeam;
};

const profileInitialState: ProfileState = {};

const navigation = createSlice({
    name: 'profile',
    initialState: profileInitialState,
    reducers: {
        setPublicProfile: (
            state: ProfileState,
            action: PayloadAction<PublicProfileTipRules>,
        ) => {
            state.tipRules = action.payload.tipRules;
            state.publicProfile = action.payload.publicProfile;
            state.publicTeam = undefined;
        },
        setPublicTeam: (
            state: ProfileState,
            action: PayloadAction<PublicTeamTipRules>,
        ) => {
            state.tipRules = action.payload.tipRules;
            state.publicTeam = action.payload.publicTeam;
            state.publicProfile = undefined;
        },
        clearProfiles: (state: ProfileState) => {
            state.tipRules = undefined;
            state.publicProfile = undefined;
            state.publicTeam = undefined;
        },
    },
});

export const { setPublicProfile, setPublicTeam, clearProfiles } =
    navigation.actions;

export default navigation.reducer;
